import { useCombobox, UseComboboxStateChangeOptions, UseComboboxState } from 'downshift'

/**
 * useComboBox stateReducer used to customize downshift default state changes
 * @see https://www.downshift-js.com/use-combobox
 * @see https://github.com/downshift-js/downshift/tree/master/src/hooks/useCombobox#statereducer
 */
export const comboboxStateReducer = <T>(
  state: UseComboboxState<T>,
  { changes, type }: UseComboboxStateChangeOptions<T>,
  creatable: boolean,
  filteredOptions: any,
  inputValue: string | undefined,
  defaultInputValue: string,
  multiple: boolean,
) => {
  // ---- SINGLE + MULTIPLE modes ---- //
  if (type === useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem) {
    if (!changes.selectedItem && defaultInputValue !== '') {
      // avoid resetting inputValue state initially when defaultInputValue is defined
      return { ...changes, inputValue: defaultInputValue }
    }
  }

  // ---- MULTIPLE MODE ---- //
  if (!multiple) return changes
  switch (type) {
    case useCombobox.stateChangeTypes.InputChange:
      // force highlighted index on creatable option when it's the only one
      if (creatable && inputValue !== '' && filteredOptions.length === 0) {
        return { ...changes, highlightedIndex: 0 }
      }
      break
    case useCombobox.stateChangeTypes.InputKeyDownEnter:
    case useCombobox.stateChangeTypes.ItemClick:
      // keep menu opened and current highlighted index when selecting an item
      return {
        ...changes,
        highlightedIndex: state.highlightedIndex,
        isOpen: true,
      }
  }
  return changes
}
